module.exports = __webpack_public_path__ + "static/media/4.e49754b7.JPG";